import { graphql, readInlineData } from 'react-relay';
import { type areFiltersApplied_itemSearch$key } from './__generated__/areFiltersApplied_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment areFiltersApplied_itemSearch on ItemSearchQueryConnection @inline {
        appliedFilters {
            name
        }
    }
`;

export type AreFiltersAppliedItemSearch = areFiltersApplied_itemSearch$key | null | undefined;

export const areFiltersApplied = (
    itemSearchRef: AreFiltersAppliedItemSearch,
    filterNames: string[]
): boolean => {
    if (!itemSearchRef) {
        return false;
    }
    const itemSearch = readInlineData(itemSearchFragment, itemSearchRef) || {};
    return (itemSearch.appliedFilters || []).some(
        filter => filter?.name && filterNames.includes(filter.name)
    );
};
